/* eslint-disable react/jsx-key */
"use client";

import React, { useEffect } from "react";
import PortfolioResponsiveDisplays from "@/app/components/PortfolioResponsiveDisplays/PortfolioResponsiveDisplays";
import WebsiteLogo from "@/app/components/WebsiteLogo/websitelogo";
import { WebsiteSubtitle } from "@/app/components/WebsiteSubtitle/WebsiteSubtitle";
import PortfolioTypography from "@/app/components/PortfolioTypography/PortfolioTypography";
import PortfolioColorscheme from "@/app/components/PortfolioColorscheme/PortfolioColorscheme";
import PortfolioTechStack from "@/app/components/PortfolioTechStack/PortfolioTechStack";
import HTML5Logo from "@/app/components/icons/HTML5Logo";
import CSS3Logo from "@/app/components/icons/CSS3Logo";
import JSLogo from "@/app/components/icons/JSLogo";
import PHPLogo from "@/app/components/icons/PHPLogo";
import WordpressLogo from "@/app/components/icons/WordpressLogo";
import GoogleSearchLogo from "@/app/components/icons/googleSearchLogo";
import PageSpeedInsightLogo from "@/app/components/icons/pageSpeedInsightLogo";
import FirstBlockAbout from "@/components/common/FirstBlockAbout";

export default function Prismpm() {
  const primaryColor = "#093F5E";
  useEffect(() => {
    // Dynamically add the Google font to the document head
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100..700;1,100..700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link); // Cleanup on unmount
    };
  }, []);

  return (
    <>
      <section className="flex flex-col gap-[100px] my-[35px]">
        <div>
          <WebsiteLogo imageSrc="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FPrismpm%2FprismpmLogo.webp?alt=media&token=50bf8ce6-508c-4ed6-903d-ad5887ab01bb" />
          <FirstBlockAbout
            media={{
              type: "image",
              src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FPrismpm%2Fprismpmbackground.webp?alt=media&token=8b5a78b3-f9b1-47de-ab1a-739129555b2d",
            }}
            primaryColor={primaryColor}
          />
          <WebsiteSubtitle
            text="For Prism Property Management, specialists in sought-after residential rentals across Southern Ontario, we executed a full website redesign to elevate their online presence and streamline property showcasing. This involved developing a custom WordPress theme and bespoke Elementor widgets, allowing for a flexible and stylish presentation of their diverse urban and heritage suites. Key to this project was significant work on their database to ensure seamless management and display of property information. To maximize their reach, we implemented comprehensive SEO strategies across multiple pages, enhancing their visibility to potential tenants seeking comfort, convenience, and style in Southern Ontario."
            title="Deliverables"
            tags={["TYPOGRAPHY", "COLORSCHEME", "RESPONSIVE DESIGN", "TECH STACK"]}
            buttonHref="https://prismpm.ca/"
          />
        </div>

        <PortfolioTypography
          typographyData={[
            {
              headline:
                "We take pride in managing some of the most sought-after residential rental properties",
              fontFamily: "Graphik Light",
              fontSize: "36px",
              letterSpacing: "0%",
              lineHeight: "auto",
              textColor: "#2c2d2c",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioColorscheme
          ColorschemeData={[
            {
              title: "Main color",
              color: "#093D5F",
              rgb: "#093D5F",
              textColor: "#ffffff",
            },
            {
              title: "White",
              color: "#FFFFFF",
              rgb: "#FFFFFF",
              textColor: "#2c2d2c",
            },
            {
              title: "Black",
              color: "#333",
              rgb: "#333",
              textColor: "#FFFFFF",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioResponsiveDisplays
          ResponsiveDisplaysData={[
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FPrismpm%2Fprismpmpc.webp?alt=media&token=2a441e28-0c54-4fd5-b05c-a8342078e997",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FPrismpm%2Fprismpmipad.webp?alt=media&token=4f6d0798-a9a3-4806-8f14-7625830b3fc5",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FPrismpm%2Fprismpmmobile.webp?alt=media&token=82bf69b5-f7fc-4bac-9e58-b030504e397c",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioTechStack
          primaryColor={primaryColor}
          blocks={[
            {
              title: "SEO Optimization",
              icons: [<GoogleSearchLogo />, <PageSpeedInsightLogo />],
              opacity: 5,
            },
            {
              title: "Layout Development",
              icons: [<HTML5Logo />, <CSS3Logo />, <JSLogo />],
              opacity: 15,
            },
            {
              title: "Theme Development",
              icons: [<PHPLogo />],
              opacity: 25,
            },
            {
              title: "Publishing",
              icons: [<WordpressLogo />],
              opacity: 30,
            },
          ]}
        />
      </section>
    </>
  );
}
